import { render } from "./huiheng_class.vue?vue&type=template&id=b2b3084a&scoped=true"
import script from "./huiheng_class.vue?vue&type=script&lang=js"
export * from "./huiheng_class.vue?vue&type=script&lang=js"

import "./huiheng_class.vue?vue&type=style&index=0&id=b2b3084a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2b3084a"]])

export default __exports__